var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConnectionNode = function SvgConnectionNode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12 16.478.858-2.678 2.616 1.273L15.12 12h2.762l-.355 3.073 2.637-1.251.837 2.656-2.826.593 1.947 2.217L17.902 21 16.5 18.344l-1.423 2.634-2.219-1.712 1.968-2.195z"
  })));
};
export { SvgConnectionNode as ReactComponent };
export default "data:image/svg+xml,%3csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M12 16.478L12.8581 13.8L15.4744 15.0732L15.1186 12H17.8814L17.5256 15.0732L20.1628 13.822L21 16.478L18.1744 17.0707L20.1209 19.2878L17.9023 21L16.5 18.3439L15.0767 20.978L12.8581 19.2659L14.8256 17.0707L12 16.478Z' fill='%234A6067'/%3e %3c/svg%3e";